__turbopack_context__.v({
  "Feature": "mains-crash-course-module__7MBjNW__Feature",
  "acheiverrank": "mains-crash-course-module__7MBjNW__acheiverrank",
  "contactheader": "mains-crash-course-module__7MBjNW__contactheader",
  "dayValue": "mains-crash-course-module__7MBjNW__dayValue",
  "facultyborder1": "mains-crash-course-module__7MBjNW__facultyborder1",
  "invalidCheck2": "mains-crash-course-module__7MBjNW__invalidCheck2",
  "mbtableheading": "mains-crash-course-module__7MBjNW__mbtableheading",
  "normalbutton": "mains-crash-course-module__7MBjNW__normalbutton",
  "pagemaintitle": "mains-crash-course-module__7MBjNW__pagemaintitle",
  "paybill": "mains-crash-course-module__7MBjNW__paybill",
  "phoneiconcss": "mains-crash-course-module__7MBjNW__phoneiconcss",
  "redunderline": "mains-crash-course-module__7MBjNW__redunderline",
  "sectionredtitle": "mains-crash-course-module__7MBjNW__sectionredtitle",
  "sectiontitle": "mains-crash-course-module__7MBjNW__sectiontitle",
  "sectiontitle2": "mains-crash-course-module__7MBjNW__sectiontitle2",
  "sectiontitlesub": "mains-crash-course-module__7MBjNW__sectiontitlesub",
  "startDate": "mains-crash-course-module__7MBjNW__startDate",
  "table1": "mains-crash-course-module__7MBjNW__table1",
  "tableheading": "mains-crash-course-module__7MBjNW__tableheading",
  "tablepara": "mains-crash-course-module__7MBjNW__tablepara",
  "tablepara1": "mains-crash-course-module__7MBjNW__tablepara1",
  "tablescroll": "mains-crash-course-module__7MBjNW__tablescroll",
  "tabletitle": "mains-crash-course-module__7MBjNW__tabletitle",
  "ulclass": "mains-crash-course-module__7MBjNW__ulclass",
  "ulliclass": "mains-crash-course-module__7MBjNW__ulliclass",
  "ullispan": "mains-crash-course-module__7MBjNW__ullispan",
});
